import React, { Component } from "react";
import { connect } from "react-redux";
import TextFieldGroup from "../../commons/TextFieldGroup";
import axios from "axios";
import isEmpty from "../../validation/is-empty";
import MessageBoxInfo from "../../commons/MessageBoxInfo";
import Searchbar from "../../commons/Searchbar";
import classnames from "classnames";

import {
  Layout,
  Breadcrumb,
  Form,
  Tabs,
  Table,
  Icon,
  message,
  Input,
  Divider,
  Row,
  Col,
  Checkbox,
  DatePicker,
  Space,
  Button,
} from "antd";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import moment from "moment";
import {
  formItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
  tailFormItemLayout,
} from "../../utils/Layouts";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import { senior_discount_options } from "../../utils/Options";
import { SENIOR_DISC_RATIO } from "../../utils/constants";
import { addKeysToArray } from "./../../utils/utilities";
import CheckboxGroupFieldGroup from "../../commons/CheckboxGroupFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { debounce } from "lodash";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";

const { Content } = Layout;
const TabPane = Tabs.TabPane;
const { RangePicker } = DatePicker;

const title = "Products Form";
const collection_name = "products";

const form_data_add_on = {
  product: "",
};

const form_data_alternative = {
  product: "",
};

const form_data_raw_material = {
  raw_material: "",
  raw_material_quantity: "",
};

const form_data_variation = {
  price: "",
  variation: "",
};

const form_data = {
  [collection_name]: [],
  _id: "",

  add_on: {
    ...form_data_add_on,
  },

  raw_material: {
    ...form_data_raw_material,
  },

  variation: {
    ...form_data_variation,
  },

  alternative: {
    ...form_data_alternative,
  },

  period_covered: null,
  name: "",
  sku: "",
  sequence: "",
  uom: "pc",
  description: "",
  category: {},
  price: "",
  retail_price: "",
  products_suggestions: [],
  taxable: true,
  is_hidden: false,
  is_with_printed_sticker: true,
  type_of_senior_discount: SENIOR_DISC_RATIO,

  raw_materials: [],
  variations: [
    {
      variation: "M",
      price: 0,
    },
    {
      variation: "L",
      price: 10,
    },
  ],
  add_ons: [],
  product_options: [],
  product_option: "",

  alternative_options: [],
  alternatives: [],

  edit_raw_material_index: null,
  edit_variation_index: null,
  edit_paper_presentation_index: null,
  edit_publication_index: null,

  is_gift_check: false,
  meat_types: [],

  unit_product: null,
  pieces_in_case: "",
  reorder_level: "",
  quantity_not_counted: false,
  is_highlighted: false,
  is_highlighted_line_2: false,

  tieup_prices: [],

  errors: {},
  serving_size: 1,
};

const search_sequence_options = [
  {
    _id: "name",
    name: "Name",
  },
  {
    _id: "sequence",
    name: "Sequence",
  },
];
class TieupProductForm extends Component {
  state = {
    title: "Products",
    url: "/api/products/",
    search_keyword: "",
    ...form_data,
    options: {
      meat_types: [],
    },
    raw_material_options: [],
    category_options: [],
    product_options: [],
    add_on_options: [],
    search_category: null,
  };

  constructor(props) {
    super(props);
    this.add_on_field = React.createRef();
    this.alternative_field = React.createRef();

    this.variation_field = React.createRef();
    this.variation_price_field = React.createRef();
    this.variation_add_button = React.createRef();

    this.raw_material_field = React.createRef();
    this.raw_material_quantity_field = React.createRef();
    this.raw_material_variation_field = React.createRef();
    this.raw_material_add_button = React.createRef();
  }

  componentDidMount() {
    axios.get("/api/tieups").then((response) => {
      if (response.data) {
        this.setState(
          {
            tieups: [...response.data],
          },
          () => {
            this.onSearch();
          }
        );
      }
    });
  }

  onChange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (e.target.type === "checkbox") {
      this.setState({ [e.target.name]: value });
    } else {
      this.setState({ [e.target.name]: value.toUpperCase() });
    }
  };

  onObjectChange = (object, e) => {
    this.setState({
      [object]: {
        ...this.state[object],
        [e.target.name]: e.target.value,
      },
    });
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();

    const form_data = {
      ...this.state,
      user: this.props.auth.user,
    };

    if (isEmpty(this.state._id)) {
      axios
        .put(this.state.url, form_data)
        .then(({ data }) => {
          message.success("Transaction Saved");
          this.setState({
            ...form_data,
            raw_material: { ...form_data_raw_material },
            edit_raw_material_index: null,
            ...data,
            errors: {},
            message: "Transaction Saved",
          });
        })
        .catch((err) => this.setState({ errors: err.response.data }));
    } else {
      axios
        .post(this.state.url + this.state._id, form_data)
        .then(({ data }) => {
          message.success("Transaction Updated");
          this.setState({
            ...form_data,
            raw_material: { ...form_data_raw_material },
            edit_raw_material_index: null,
            ...data,
            errors: {},
            message: "Transaction Updated",
          });
        })
        .catch((err) => this.setState({ errors: err?.response?.data }));
    }
  };

  onSearch = (e) => {
    if (e) e.preventDefault();
    const loading = message.loading("Loading...");

    axios
      .get(
        this.state.url +
          "?" +
          `${
            !isEmpty(this.state.search_keyword) &&
            `&s=${this.state.search_keyword}`
          }` +
          `${
            !isEmpty(this.state.search_category)
              ? `&category_id=${this.state.search_category?._id}`
              : ""
          }${
            !isEmpty(this.state.search_sequence)
              ? `&sequence=${this.state.search_sequence?._id}`
              : ""
          }${
            !isEmpty(this.state.search_main_category?._id)
              ? `&main_category_id=${this.state.search_main_category?._id}`
              : ""
          }`
      )
      .then((response) => {
        loading();
        this.setState({
          [collection_name]: response.data,
          message: isEmpty(response.data) ? "No rows found" : "",
        });
      })
      .catch((err) => {
        loading();
        message.error("There was an error processing your request.");
        console.log(err);
      });
  };

  addNew = () => {
    this.setState({
      ...form_data,
      errors: {},
      message: "",
    });
  };

  onEditRawMaterial = (record, index) => {
    this.setState({
      raw_material: {
        ...record,
      },
      edit_raw_material_index: index,
    });
  };
  onEditVariation = (record, index) => {
    this.setState(
      {
        variation: {
          ...record,
        },
        edit_variation_index: index,
      },
      () => {
        this.variation_field.focus();
      }
    );
  };

  onUpdateRawMaterial = () => {
    const raw_materials = [...this.state.raw_materials];
    raw_materials[this.state.edit_raw_material_index] = {
      ...raw_materials[this.state.edit_raw_material_index],
      ...this.state.raw_material,
    };

    this.setState(
      {
        raw_materials,
        raw_material: {
          ...form_data_raw_material,
        },
        edit_raw_material_index: null,
      },
      message.success("Raw Material Updated")
    );
  };

  onUpdateVariation = () => {
    const variations = [...this.state.variations];
    variations[this.state.edit_variation_index] = {
      ...variations[this.state.edit_variation_index],
      ...this.state.variation,
    };

    this.setState(
      {
        variations,
        variation: {
          ...form_data_variation,
        },
        edit_variation_index: null,
      },
      message.success("Variation Updated")
    );
  };

  onDeleteRawMaterial = (record, index) => {
    const raw_materials = [...this.state.raw_materials];
    raw_materials.splice(index, 1);
    this.setState({ raw_materials });
  };
  onDeleteVariation = (record, index) => {
    const variations = [...this.state.variations];
    variations.splice(index, 1);
    this.setState({ variations });
  };

  onDeleteAddOn = (record, index) => {
    const add_ons = [...this.state.add_ons];
    add_ons.splice(index, 1);
    this.setState({ add_ons });
  };

  onDeleteAlternative = (record, index) => {
    const alternatives = [...this.state.alternatives];
    alternatives.splice(index, 1);
    this.setState({ alternatives });
  };

  onDeleteProductOption = (record, index) => {
    const product_options = [...this.state.product_options];
    product_options.splice(index, 1);
    this.setState({ product_options });
  };

  onDelete = () => {
    axios
      .delete(this.state.url + this.state._id, {
        data: {
          uesr: this.props.auth.user,
        },
      })
      .then((response) => {
        this.setState({
          ...form_data,
          message: "Transaction Deleted",
        });
      })
      .catch((err) => console.log(err));
  };

  onHide = () => {
    this.setState({ message: "" });
  };

  onRawMaterialSearch = (value) => {
    axios
      .get(`/api/products/listings?s=${value}`)
      .then((response) =>
        this.setState({ raw_material_options: response.data })
      )
      .catch((err) => console.log(err));
  };

  onRawMaterialChange = (value) => {
    this.setState(
      (prevState) => {
        return {
          raw_material: {
            ...prevState.raw_material,
            raw_material: prevState.raw_material_options[value],
          },
        };
      },
      () => {
        this.raw_material_quantity_field.focus();
      }
    );
  };

  onVariationChange = (value) => {
    this.setState((prevState) => {
      return {
        variation: {
          ...prevState.variation,
          variation: prevState.raw_material_options[value],
        },
      };
    });
  };

  onAlternativeSearch = (value) => {
    axios
      .get(`/api/products/listings?s=${value}`)
      .then((response) => this.setState({ alternative_options: response.data }))
      .catch((err) => console.log(err));
  };

  onAlternativeChange = (value) => {
    this.setState((prevState) => {
      return {
        alternative: {
          ...prevState.alternative,
          product: prevState.alternative_options[value],
        },
      };
    });
  };

  onAddOnSearch = (value) => {
    axios
      .get(`/api/products/?s=${value}`)
      .then((response) => this.setState({ add_on_options: response.data }))
      .catch((err) => console.log(err));
  };

  onAddOnChange = (value) => {
    this.setState((prevState) => {
      return {
        add_on: {
          ...prevState.add_on,
          product: prevState.add_on_options[value],
        },
      };
    });
  };

  onCategorySearch = debounce((value) => {
    axios
      .get(`/api/categories/?s=${value}`)
      .then((response) => this.setState({ category_options: response.data }))
      .catch((err) => console.log(err));
  }, 200);

  onSubcategorySearch = debounce((value) => {
    axios
      .get(`/api/subcategories/?s=${value}`)
      .then((response) => this.setState({ subcategory_options: response.data }))
      .catch((err) => console.log(err));
  }, 200);

  onMainCategorySearch = debounce((value) => {
    axios
      .get(`/api/main-categories/?s=${value}`)
      .then((response) =>
        this.setState({ main_category_options: response.data })
      )
      .catch((err) => console.log(err));
  }, 200);

  onPrinterStationSearch = debounce((value) => {
    axios
      .get(`/api/printer-stations/?s=${value}`)
      .then((response) =>
        this.setState({ printer_station_options: response.data })
      )
      .catch((err) => console.log(err));
  }, 200);

  onCategoryChange = (value) => {
    this.setState((prevState) => {
      return {
        category: prevState.category_options[value],
      };
    });
  };
  onSubcategoryChange = (value) => {
    this.setState((prevState) => {
      return {
        subcategory: prevState.subcategory_options[value],
      };
    });
  };
  onMainCategoryChange = (index) => {
    this.setState((prevState) => {
      return {
        main_category: prevState.main_category_options?.[index] || null,
      };
    });
  };
  onPrinterStationChange = (index) => {
    this.setState((prevState) => {
      return {
        printer_stations: prevState.printer_station_options?.[index] || null,
      };
    });
  };

  onProductSearch = (value) => {
    axios
      .get(`/api/products/?s=${value}`)
      .then((response) => this.setState({ product_options: response.data }))
      .catch((err) => console.log(err));
  };

  onProductChange = (value) => {
    this.setState((prevState) => {
      return {
        unit_product: prevState.product_options[value],
      };
    });
  };

  onAddRawMaterial = () => {
    const raw_materials = [
      ...this.state.raw_materials,
      {
        ...this.state.raw_material,
      },
    ];

    this.setState(
      {
        raw_materials,
        raw_material: {
          ...form_data_raw_material,
        },
      },
      () => {
        this.raw_material_field.focus();
      }
    );
  };

  onAddVariation = () => {
    const variations = [
      ...this.state.variations,
      {
        ...this.state.variation,
      },
    ];

    this.setState(
      {
        variations,
        variation: {
          ...form_data_variation,
        },
      },
      () => this.variation_field.focus()
    );
  };

  onAddAddOn = () => {
    if (isEmpty(this.state.add_on.product)) {
      message.error("Unable to add add-on ; Please select span product");
      return;
    }

    const add_ons = [
      ...this.state.add_ons,
      {
        ...this.state.add_on,
      },
    ];

    this.setState({
      add_ons,
      add_on: {
        ...form_data_add_on,
      },
    });

    this.add_on_field.current.focus();
  };

  onAddAlternative = () => {
    if (isEmpty(this.state.alternative.product)) {
      message.error("Unable to add alternative ; Please select span product");
      return;
    }

    const alternatives = [
      ...this.state.alternatives,
      {
        ...this.state.alternative,
      },
    ];

    this.setState({
      alternatives,
      alternative: {
        ...form_data_alternative,
      },
    });

    this.alternative_field.current.focus();
  };

  onAddProductOption = (e) => {
    e.preventDefault();
    if (isEmpty(this.state.product_option)) {
      message.error("Unable to add product option ; Please supply an option");
      return;
    }

    const product_options = [
      ...this.state.product_options,
      this.state.product_option,
    ];

    this.setState({
      product_options,
      product_option: "",
    });
  };

  edit = (record) => {
    axios
      .get(this.state.url + record._id)
      .then((response) => {
        const record = response.data;
        this.setState((prevState) => {
          return {
            ...form_data,
            edit_raw_material_index: null,
            edit_paper_presentation_index: null,
            edit_publication_index: null,
            [collection_name]: [],
            ...record,
            date_approved: record.date_approved
              ? moment(record.date_approved)
              : null,
            date_of_completion: record.date_of_completion
              ? moment(record.date_of_completion)
              : null,
            errors: {},
          };
        });
      })
      .catch((err) => console.log(err));
  };

  onCloneProduct = (record) => {
    const loading = message.loading("Loading...");
    axios.get(`/api/products/${record._id}`).then((response) => {
      const product = response.data;
      delete product._id;
      delete product.name;
      this.setState({
        ...form_data,
        ...product,
        [collection_name]: [],
      });
      loading();
    });
  };

  onChangeTieupPrice = ({ price, index }) => {
    let tieup_prices = [...this.state.tieup_prices];
    tieup_prices[index] = {
      ...tieup_prices[index],
      price,
    };
    this.setState({ tieup_prices });
  };

  onDownloadExcel = ({ records, tieups }) => {
    axios
      .post("/api/products/download-tieup-prices", {
        records: [...records],
        tieups,
      })
      .then((response) => {
        window.open(`/public/reports/${response.data.filename}`);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.search_category !== this.state.search_category ||
      prevState.search_sequence !== this.state.search_sequence
    ) {
      this.onSearch();
    }
  }

  render() {
    const raw_materials_column = [
      {
        title: "Name",
        dataIndex: ["raw_material", "name"],
      },
      {
        title: "Quantity",
        dataIndex: "raw_material_quantity",
      },
      {
        title: "Variation",
        dataIndex: "variation",
      },
      {
        title: "",
        key: "action",
        width: 100,
        render: (text, record, index) => (
          <span>
            <EditOutlined
              onClick={() => this.onEditRawMaterial(record, index)}
            />

            <Divider type="vertical" />
            <DeleteOutlined
              onClick={() => this.onDeleteRawMaterial(record, index)}
            />
          </span>
        ),
      },
    ];

    const variations_column = [
      {
        title: "Variation",
        dataIndex: "variation",
      },
      {
        title: "Price",
        dataIndex: "price",
      },
      {
        title: "",
        key: "action",
        width: 100,
        render: (text, record, index) => (
          <span>
            <EditOutlined onClick={() => this.onEditVariation(record, index)} />
            <Divider type="vertical" />
            <DeleteOutlined
              onClick={() => this.onDeleteVariation(record, index)}
            />
          </span>
        ),
      },
    ];

    const records_column = [
      {
        title: "Product",
        dataIndex: "name",
      },

      {
        title: "Category",
        dataIndex: ["category", "name"],
      },
      {
        title: "Subategory",
        dataIndex: ["subcategory", "name"],
      },

      {
        title: "Price",
        dataIndex: "price",
        align: "right",
        render: (value, record) => (
          <Input
            defaultValue={value}
            className="table-input-price"
            onBlur={(e) => {
              axios
                .post(`/api/products/${record._id}/price`, {
                  price: e.target.value,
                })
                .then(() => message.success(`${record.name} price updated`))
                .catch((err) => console.log(err));
            }}
          />
        ),
      },

      ...[
        ...(this.state.tieups || [])?.map((tieup) => {
          return {
            title: tieup.name,
            width: 30,
            key: "tieup_prices",
            align: "center",
            render: (value, record) => {
              const tieup_price =
                (record.tieup_prices || [])?.filter((o) => {
                  return o.tieup?._id === tieup?._id;
                })?.[0]?.price || "";

              return (
                <span>
                  <Input
                    defaultValue={tieup_price}
                    className="table-input-price"
                    onBlur={(e) => {
                      axios
                        .post(`/api/products/${record._id}/tieup-price`, {
                          price: e.target.value,
                          tieup,
                        })
                        .then(() =>
                          message.success(
                            `${record.name} ${tieup.name} price updated`
                          )
                        )
                        .catch((err) => console.log(err));
                    }}
                  />
                </span>
              );
            },
          };
        }),
      ],

      // {
      //   title: "Serving",
      //   dataIndex: "serving_size",
      //   align: "center",
      //   render: (value, record) => (
      //     <Input
      //       defaultValue={value}
      //       className="table-input-short"
      //       onBlur={(e) => {
      //         axios
      //           .post(`/api/products/${record._id}/serving-size`, {
      //             serving_size: e.target.value,
      //           })
      //           .then(() => message.success(`${record.name} serving updated`))
      //           .catch((err) => console.log(err));
      //       }}
      //     />
      //   ),
      // },
      {
        title: "Hidden",
        dataIndex: "is_hidden",
        align: "center",
        render: (is_hidden, record, index) => (
          <Checkbox
            defaultChecked={is_hidden}
            onChange={(e) => {
              const checked = e.target.checked;

              axios
                .post(`/api/products/${record._id}/is-hidden`, {
                  is_hidden: checked,
                })
                .then(() => {
                  message.success("Item updated");
                })
                .catch((err) => {
                  message.error("There was a problem processing your request");
                });
            }}
          />
        ),
      },
      // {
      //   title: "W/SC",
      //   dataIndex: "with_service_charge",
      //   align: "center",
      //   render: (with_service_charge, record, index) => (
      //     <Checkbox
      //       defaultChecked={with_service_charge}
      //       onChange={(e) => {
      //         const checked = e.target.checked;

      //         axios
      //           .post(`/api/products/${record._id}/with-service-charge`, {
      //             with_service_charge: checked,
      //           })
      //           .then(() => {
      //             message.success("Item updated");
      //           })
      //           .catch((err) => {
      //             message.error("There was a problem processing your request");
      //           });
      //       }}
      //     />
      //   ),
      // },

      // {
      //   title: "",
      //   width: 30,
      //   key: "action",
      //   render: (text, record) => (
      //     <span>
      //       <EditOutlined onClick={() => this.edit(record)} />
      //     </span>
      //   ),
      // },
    ];

    const tieup_column = [
      {
        title: "Tieup",
        dataIndex: ["tieup", "name"],
      },
      {
        title: "Variation",
        dataIndex: "variation",
      },

      {
        title: "Price",
        dataIndex: "price",
        width: 200,
        render: (price, record, index) => {
          return (
            <Input
              value={price}
              onChange={(e) =>
                this.onChangeTieupPrice({ price: e.target.value, index })
              }
              className="has-text-right"
            />
          );
        },
      },
    ];

    const { errors } = this.state;

    return (
      <Content>
        <Row>
          <Col span={4}>
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={20}>
            <div className="is-flex flex-direction-row stock-category-search">
              <div style={{ width: "400px" }}>
                <SelectFieldGroup
                  label="Main Category"
                  name="name"
                  value={this.state.search_main_category?.name}
                  onChange={(index) => {
                    this.setState((prevState) => {
                      return {
                        search_main_category:
                          prevState.main_category_options?.[index] || null,
                      };
                    });
                  }}
                  onSearch={this.onMainCategorySearch}
                  formItemLayout={smallFormItemLayout}
                  data={this.state.main_category_options}
                />
              </div>
              <div style={{ width: "400px" }}>
                <SelectFieldGroup
                  label="Category"
                  name="name"
                  value={this.state.search_category?.name}
                  onChange={(value) => {
                    this.setState((prevState) => {
                      return {
                        search_category:
                          prevState.category_options?.[value] || null,
                      };
                    });
                  }}
                  onSearch={this.onCategorySearch}
                  formItemLayout={smallFormItemLayout}
                  data={this.state.category_options}
                />
              </div>
              <div style={{ width: "250px" }}>
                <SelectFieldGroup
                  label="Sequence"
                  name="search_sequence"
                  value={this.state.search_sequence?.name}
                  onChange={(value) => {
                    this.setState({
                      search_sequence: search_sequence_options?.[value] || null,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={search_sequence_options}
                />
              </div>

              <Searchbar
                name="search_keyword"
                onSearch={(value, e) => this.onSearch(e)}
                onChange={this.onChange}
                value={this.state.search_keyword}
              />
            </div>
          </Col>
        </Row>

        <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
          <span className="is-size-5">{this.state.title}</span> <hr />
          <MessageBoxInfo message={this.state.message} onHide={this.onHide} />
          {isEmpty(this.state[collection_name]) ? (
            <Form onFinish={() => this.onSubmit()}>
              <div>
                <TextFieldGroup
                  label="Product Name"
                  name="name"
                  value={this.state.name}
                  onChange={this.onChange}
                  error={errors.name}
                  formItemLayout={smallFormItemLayout}
                />

                <TextFieldGroup
                  label="SKU"
                  name="sku"
                  value={this.state.sku}
                  onChange={this.onChange}
                  error={errors.sku}
                  formItemLayout={smallFormItemLayout}
                />

                <TextFieldGroup
                  type="number"
                  label="Serving Size"
                  name="serving_size"
                  value={this.state.serving_size}
                  onChange={this.onChange}
                  error={errors.serving_size}
                  formItemLayout={smallFormItemLayout}
                />

                <TextFieldGroup
                  label="Sequence"
                  name="sequence"
                  value={this.state.sequence}
                  onChange={this.onChange}
                  error={errors.sequence}
                  formItemLayout={smallFormItemLayout}
                />

                <TextFieldGroup
                  type="number"
                  label="Price"
                  name="price"
                  value={this.state.price}
                  onChange={this.onChange}
                  error={errors.price}
                  formItemLayout={smallFormItemLayout}
                />

                {/*                     <TextFieldGroup
                      type="number"
                      label="Retail Price"
                      name="retail_price"
                      value={this.state.retail_price}
                      onChange={this.onChange}
                      error={errors.retail_price}
                      formItemLayout={smallFormItemLayout}
                    /> */}

                <TextFieldGroup
                  label="U.O.M."
                  name="uom"
                  value={this.state.uom}
                  onChange={this.onChange}
                  error={errors.uom}
                  formItemLayout={smallFormItemLayout}
                />

                <SelectFieldGroup
                  label="Main Category"
                  name="name"
                  value={this.state.main_category?.name || ""}
                  onChange={this.onMainCategoryChange}
                  onSearch={this.onMainCategorySearch}
                  error={errors.main_category}
                  formItemLayout={smallFormItemLayout}
                  data={this.state.main_category_options}
                />

                <SelectFieldGroup
                  label="Category"
                  name="name"
                  value={this.state.category && this.state.category.name}
                  onChange={this.onCategoryChange}
                  onSearch={this.onCategorySearch}
                  error={errors.category && errors.category}
                  formItemLayout={smallFormItemLayout}
                  data={this.state.category_options}
                />

                <SelectFieldGroup
                  label="Subcategory"
                  name="name"
                  value={this.state.subcategory?.name || ""}
                  onChange={this.onSubcategoryChange}
                  onSearch={this.onSubcategorySearch}
                  error={errors.subcategory}
                  formItemLayout={smallFormItemLayout}
                  data={this.state.subcategory_options}
                />

                {/* {this.state.category && (
                      <SelectFieldGroup
                        label="Station"
                        name="name"
                        value={this.state.category?.station?.name}
                        onChange={this.onStationChange}
                        onSearch={this.onStationSearch}
                        error={errors.station && errors.station.name}
                        formItemLayout={smallFormItemLayout}
                        data={this.state.station_options}
                      />
                    )} */}

                {/* <CheckboxGroupFieldGroup
                      label="Meat Type(s)"
                      onChange={(value) => {
                        this.setState({
                          meat_types: value,
                        });
                      }}
                      options={this.state.options.meat_types}
                      value={this.state.meat_types}
                      formItemLayout={smallFormItemLayout}
                    /> */}

                <TextFieldGroup
                  label="Description"
                  name="description"
                  value={this.state.description}
                  onChange={this.onChange}
                  error={errors.description}
                  formItemLayout={smallFormItemLayout}
                />

                {/* <SelectFieldGroup
                      label="Unit Product"
                      name="name"
                      value={
                        this.state.unit_product && this.state.unit_product.name
                      }
                      onChange={this.onProductChange}
                      onSearch={this.onProductSearch}
                      error={errors.unit_product && errors.unit_product.name}
                      formItemLayout={smallFormItemLayout}
                      data={this.state.product_options}
                    />

                    <TextFieldGroup
                      type="number"
                      label="Pieces in Case"
                      name="pieces_in_case"
                      value={this.state.pieces_in_case}
                      onChange={this.onChange}
                      error={errors.pieces_in_case}
                      formItemLayout={smallFormItemLayout}
                    /> */}

                {/* <TextFieldGroup
                      type="number"
                      label="Reorder Level"
                      name="reorder_level"
                      value={this.state.reorder_level}
                      onChange={this.onChange}
                      error={errors.reorder_level}
                      formItemLayout={smallFormItemLayout}
                    /> */}

                {/* <Divider />

                    <SelectFieldGroup
                      label="Add-ons"
                      name="name"
                      value={
                        this.state.add_on.product &&
                        this.state.add_on.product.name
                      }
                      onChange={this.onAddOnChange}
                      onSearch={this.onAddOnSearch}
                      error={errors.add_on && errors.add_on.name}
                      formItemLayout={smallFormItemLayout}
                      data={this.state.add_on_options}
                      inputRef={this.add_on_field}
                    />

                    <Form.Item {...tailFormItemLayout}>
                      <div className="field is-grouped">
                        <div className="control">
                          <input
                            type="button"
                            className="button is-primary is-small"
                            onClick={this.onAddAddOn}
                            value="Add"
                          />
                        </div>
                      </div>
                    </Form.Item>

                    <Table
                      dataSource={this.state.add_ons}
                      columns={add_ons_column}
                      rowKey="_id"
                    /> */}
                <CheckboxFieldGroup
                  label="With Service Charge"
                  name="with_service_charge"
                  onChange={this.onChange}
                  error={errors.with_service_charge}
                  checked={this.state.with_service_charge}
                  formItemLayout={smallFormItemLayout}
                />

                <CheckboxFieldGroup
                  label="Is Hidden at Menu"
                  name="is_hidden"
                  onChange={this.onChange}
                  error={errors.is_hidden}
                  checked={this.state.is_hidden}
                  formItemLayout={smallFormItemLayout}
                />

                <CheckboxFieldGroup
                  label="With Sticker Label"
                  name="is_with_printed_sticker"
                  onChange={this.onChange}
                  error={errors.is_with_printed_sticker}
                  checked={this.state.is_with_printed_sticker}
                  formItemLayout={smallFormItemLayout}
                />

                <CheckboxFieldGroup
                  label="Is Highlighted "
                  name="is_highlighted"
                  onChange={this.onChange}
                  error={errors.is_highlighted}
                  checked={this.state.is_highlighted}
                  formItemLayout={smallFormItemLayout}
                />
                <CheckboxFieldGroup
                  label="Is Highlighted Line 2"
                  name="is_highlighted_line_2"
                  onChange={this.onChange}
                  error={errors.is_highlighted_line_2}
                  checked={this.state.is_highlighted_line_2}
                  formItemLayout={smallFormItemLayout}
                />

                <CheckboxFieldGroup
                  label="Taxable"
                  name="taxable"
                  onChange={this.onChange}
                  error={errors.taxable}
                  checked={this.state.taxable}
                  formItemLayout={smallFormItemLayout}
                />

                <CheckboxFieldGroup
                  label="Qty not counted"
                  name="quantity_not_counted"
                  onChange={this.onChange}
                  error={errors.quantity_not_counted}
                  checked={this.state.quantity_not_counted}
                  formItemLayout={smallFormItemLayout}
                />

                {this.state.taxable && (
                  <RadioGroupFieldGroup
                    label="Type of Senior Discount"
                    name="type_of_senior_discount"
                    onChange={this.onChange}
                    error={errors.type_of_senior_discount}
                    value={this.state.type_of_senior_discount}
                    options={senior_discount_options}
                    formItemLayout={smallFormItemLayout}
                  />
                )}

                <Divider />
                <div>
                  <TextFieldGroup
                    label="Variation"
                    name="variation"
                    value={this.state.variation?.variation}
                    onChange={(e) => this.onObjectChange("variation", e)}
                    error={errors.variation?.variation}
                    formItemLayout={smallFormItemLayout}
                    inputRef={(input) => (this.variation_field = input)}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      this.variation_price_field.focus();
                    }}
                  />

                  <TextFieldGroup
                    label="Price"
                    name="price"
                    value={this.state.variation.price}
                    onChange={(e) => this.onObjectChange("variation", e)}
                    error={errors.variation && errors.variation.price}
                    formItemLayout={smallFormItemLayout}
                    inputRef={(input) => (this.variation_price_field = input)}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      this.variation_add_button.click();
                    }}
                  />

                  <Form.Item {...smallTailFormItemLayout}>
                    <div className="field is-grouped">
                      <div
                        className={classnames("control", {
                          "display-none":
                            this.state.edit_variation_index !== null,
                        })}
                      >
                        <input
                          type="button"
                          className="button is-primary is-small"
                          onClick={this.onAddVariation}
                          ref={(input) => (this.variation_add_button = input)}
                          value="Add"
                        />
                      </div>

                      <div
                        className={classnames("control", {
                          "display-none":
                            this.state.edit_variation_index === null,
                        })}
                      >
                        <input
                          type="button"
                          className="button is-primary is-small"
                          onClick={this.onUpdateVariation}
                          value="Update"
                        />
                      </div>
                    </div>
                  </Form.Item>

                  <Table
                    dataSource={this.state.variations}
                    columns={variations_column}
                    rowKey="_id"
                  />
                </div>

                <Divider />
                <div>
                  <SelectFieldGroup
                    label="Raw Material"
                    name="name"
                    value={
                      this.state.raw_material.raw_material &&
                      this.state.raw_material.raw_material.name
                    }
                    onChange={this.onRawMaterialChange}
                    onSearch={this.onRawMaterialSearch}
                    error={errors.raw_material && errors.raw_material.name}
                    formItemLayout={smallFormItemLayout}
                    data={this.state.raw_material_options}
                    inputRef={(input) => (this.raw_material_field = input)}
                  />

                  <TextFieldGroup
                    label="Quantity"
                    name="raw_material_quantity"
                    value={this.state.raw_material.raw_material_quantity}
                    onChange={(e) => this.onObjectChange("raw_material", e)}
                    error={
                      errors.raw_material &&
                      errors.raw_material.raw_material_quantity
                    }
                    formItemLayout={smallFormItemLayout}
                    inputRef={(input) =>
                      (this.raw_material_quantity_field = input)
                    }
                    onPressEnter={(e) => {
                      e.preventDefault();
                      this.raw_material_variation_field.focus();
                    }}
                  />

                  <SimpleSelectFieldGroup
                    label="Variation"
                    name="variation"
                    value={this.state?.raw_material?.variation}
                    onChange={(value) => {
                      this.setState(
                        {
                          raw_material: {
                            ...this.state.raw_material,
                            variation: value,
                          },
                        },
                        () => {
                          this.raw_material_add_button.click();
                        }
                      );
                    }}
                    error={errors.variation}
                    options={(this.state.variations || []).map(
                      (o) => o.variation
                    )}
                    formItemLayout={smallFormItemLayout}
                    inputRef={(input) =>
                      (this.raw_material_variation_field = input)
                    }
                  />

                  <Form.Item {...smallTailFormItemLayout}>
                    <div className="field is-grouped">
                      <div
                        className={classnames("control", {
                          "display-none":
                            this.state.edit_raw_material_index !== null,
                        })}
                      >
                        <input
                          type="button"
                          className="button is-primary is-small"
                          onClick={this.onAddRawMaterial}
                          value="Add"
                          ref={(input) => {
                            this.raw_material_add_button = input;
                          }}
                        />
                      </div>

                      <div
                        className={classnames("control", {
                          "display-none":
                            this.state.edit_raw_material_index === null,
                        })}
                      >
                        <input
                          type="button"
                          className="button is-primary is-small"
                          onClick={this.onUpdateRawMaterial}
                          value="Update"
                        />
                      </div>
                    </div>
                  </Form.Item>

                  <Table
                    dataSource={this.state.raw_materials}
                    columns={raw_materials_column}
                    rowKey="_id"
                  />
                </div>

                <Divider />
                {this.state.tieup_prices &&
                  this.state.tieup_prices.length > 0 && (
                    <Table
                      dataSource={addKeysToArray(this.state.tieup_prices)}
                      columns={tieup_column}
                      pagination={false}
                    />
                  )}

                <Form.Item {...formItemLayout}>
                  <div className="field is-grouped m-t-1">
                    <div className="control">
                      <button className="button is-primary is-small">
                        Save
                      </button>
                    </div>

                    {!isEmpty(this.state._id) && (
                      <div className="control">
                        <button
                          className="button is-outlined is-small"
                          onClick={(e) => {
                            e.preventDefault();
                            axios
                              .post(
                                `/api/products/${this.state._id}/update-tieup-price`
                              )
                              .then((response) => {
                                this.edit(this.state);
                              })
                              .catch((err) => {
                                message.error(
                                  "There was an error processing your request"
                                );
                              });
                          }}
                        >
                          Update Tieup Prices
                        </button>
                      </div>
                    )}

                    {!isEmpty(this.state._id) ? (
                      <span
                        className="button is-danger is-outlined is-small"
                        onClick={this.onDelete}
                      >
                        <span>Delete</span>
                        <span className="icon is-small">
                          <i className="fas fa-times" />
                        </span>
                      </span>
                    ) : null}
                  </div>
                </Form.Item>
              </div>
            </Form>
          ) : (
            [
              <button
                onClick={() => {
                  this.onDownloadExcel({
                    records: this.state[collection_name],
                    tieups: this.state.tieups,
                  });
                }}
              >
                Download to Excel
              </button>,
              <div className="products-table">
                <Table
                  dataSource={addKeysToArray(this.state[collection_name])}
                  columns={records_column}
                  rowKey={(record) => record._id}
                  pagination={{
                    pageSize: 100,
                  }}
                />
              </div>,
            ]
          )}
        </div>
      </Content>
    );
  }
}

const mapToState = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapToState)(TieupProductForm);
